import baseAPI from "@/http";

const router = "api/inscricao-sala";

export const inscricaoAPI = {
  create: (ator) => baseAPI.post(`${router}/criar-inscricao`, ator),
  update: (ator) => baseAPI.put(`${router}/atualizar-inscricao`, ator),
  delete: (id) => baseAPI.delete(`${router}/excluir-inscricao/${id}`),
  list: () => baseAPI.get(`${router}/obter-inscricoes`),
  find: (id) => baseAPI.get(`${router}/obter-inscricao-por-id?id=${id}`),
  obterInscricoesEmail: (email) =>
    baseAPI.get(`${router}/obter-inscricoes-por-email?email=${email}`),
  enviarEmailConfirmando: (inscricaoId) =>
    baseAPI.post(`${router}/confirmacao-email?id=${inscricaoId}`),
  enviarEmailValidacao: (inscricaoId) =>
    baseAPI.post(`${router}/validação-email?id=${inscricaoId}`),
  aprovarInscricao: (inscricao) =>
    baseAPI.post(`${router}/aprovar-inscricao`, inscricao),
  rejeitarInscricao: (inscricao) =>
    baseAPI.post(`${router}/rejeitar-inscricao`, inscricao),
  downloadPdf: (inscricao) =>
    baseAPI.post(`${router}/obter-pdf-selo-diagnostico`, inscricao, {
      responseType: "blob",
    }),
  downloadExcelInscritos: () =>
    baseAPI.post(`${router}/download-excel-inscritos`, null, {
      responseType: "blob",
    }),
  enviarEmailRejeicao: (inscricao) =>
    baseAPI.post(`${router}/enviar-email-rejeicao`, inscricao),
};
